export type RevenueSource = "Online" | "Phone" | "DineIn" | string;

/** Bir para birimindeki tahsilat. Para birimleri asla birbiriyle toplanmaz. */
export interface IRevenueCurrencyTotal {
  /** Arkasındaki satırların para birimi yoksa null gelebilir */
  currencyId?: string | null;
  currencyName?: string | null;
  currencyDisplayText?: string | null;
  totalAmount: number;
  /** Tutarın arkasındaki sipariş / hesap adedi */
  count: number;
}

/** Tek hücre: bir kanalın, bir ödeme yöntemiyle, bir para birimindeki tahsilatı. */
export interface IRevenuePaymentMethodBreakdown {
  /** Gruplama ve etiketleme bunun üzerinden yapılmalı — ad panelden değiştirilebiliyor. */
  paymentMethodId: string;
  paymentMethodNameTr?: string | null;
  paymentMethodNameEn?: string | null;
  /** Ödeme yöntemi hiç kaydedilmemiş tahsilat kovası. Toplamların İÇİNDEDİR, düşülmez. */
  isUnspecified: boolean;
  currencyId?: string | null;
  currencyName?: string | null;
  currencyDisplayText?: string | null;
  totalAmount: number;
  count: number;
}

export interface IRevenueSourceBreakdown {
  source: RevenueSource;
  /** Kanal hiç tahsilat yapmadıysa boş dizi */
  totals: IRevenueCurrencyTotal[];
  paymentMethods: IRevenuePaymentMethodBreakdown[];
}

export interface IRevenueReport {
  restourantId: string;
  /** Pencerenin ilk günü (DateOnly, "2026-10-01") */
  from: string;
  /** Pencerenin son günü — DAHİL */
  to: string;
  /** Sunucunun işini göstermesi; sözleşme from/to tarihleridir */
  fromUtc: string;
  /** Üst uç HARİÇ */
  toUtcExclusive: string;
  timeZoneId: string;
  /** Her zaman üç kanal da gelir; tahsilat yapmayan kanal sıfır/boş olarak döner */
  sources: IRevenueSourceBreakdown[];
  /** Pencerenin tamamı, para birimi başına bir satır */
  totals: IRevenueCurrencyTotal[];
}

/** Pencere en çok 92 takvim günü olabilir (iki uç dahil). */
export const REVENUE_MAX_WINDOW_DAYS = 92;

export const REVENUE_SOURCE_META: Record<string, { label: string; icon: string; color: string; bg: string }> = {
  Online: { label: "Online (mutfacik.com)", icon: "bi-globe2",     color: "#2563eb", bg: "#eff6ff" },
  Phone:  { label: "Telefon",               icon: "bi-telephone-fill", color: "#7c3aed", bg: "#f5f3ff" },
  DineIn: { label: "Salon",                 icon: "bi-shop-window", color: "#ea580c", bg: "#fff7ed" },
};
